import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorDO } from './../../../BaseFramework/shared/models/error.model';

import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  AppMetadataHandler
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';

interface ValidationOutput {
  isInvalid: boolean,
  errorDOs: Array<ErrorDO>
}


@Component({
  selector: 'app-claims-basic-details',
  templateUrl: './claims-basic-details.component.html',
  styleUrls: ['./claims-basic-details.component.scss']
})
export class ClaimsBasicDetailsComponent implements OnInit {
  _currentComponentName = "ClaimsBasicDetailsComponent"

  constructor(private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService,
    public appMetadataHandler: AppMetadataHandler) { }

  //Declaraions which might need developer input
  claimsBasicDetailsForm: FormGroup
  CLAIMSBASICDETAILSFORMNAME = "claimsBasicDetailsForm"
  lookupsToBind = ['clmEventTypeCd', 'clmCauseOfDeathCd', 'clmMannerOfLossCd']
  selectorOfThisComponent = 'app-claims-basic-details'
  parentEvent$

  /**
   *
   *  Ninad: Whenever any developer is creating a new Component,
   * please make sure that you copy all import commands, constructor and
   * Boiler and Component Creation Kickstart CODE 
   *
   * 
   * Component Creation Kickstart CODE   
   */

  //ComponentSpecific Inputs, Outputs
  @Output() componentOutput = new EventEmitter<any>();
  @Input() type: string;
  @Input() transactionState: string;

  private _inputDataForEdit = null;
  @Input()
  set inputDataForEdit(value: any) {
    if (value) this._inputDataForEdit = value;
  };

  clmEventTypeCd
  item

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
  }
  getParentComponent(): Component {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
    } catch { }
  }
  getParentComponentName(): string {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
    } catch { }
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      let validationResult = this.validateOutput(this.claimsBasicDetailsForm)
      if (!validationResult.isInvalid)
        this.EmitComponentOutput(this.claimsBasicDetailsForm)
      else {
        this.EmitComponentOutput(validationResult)
      }
    })
  }


  validateOutput(o): ValidationOutput {
    this.commonUtilty.markAllFieldDirty(o);

    let validationOutput: ValidationOutput = {
      isInvalid: null,
      errorDOs: []
    }
    validationOutput.errorDOs = this.checkInvalidAndEmptyFields(o, this.getCurrentComponentName())
    if (!this.isdateValid) {
      let errorDO = new ErrorDO()
      errorDO.errorMsg = "Event date and Retype Event Date mismatch";
      errorDO.componentName = this.getCurrentComponentName();
      errorDO.fieldName = "Event Date"
    }

    if (Array.isArray(validationOutput.errorDOs) && validationOutput.errorDOs.length > 0) {
      validationOutput.isInvalid = true;
    }
    else {
      validationOutput.isInvalid = false;
    }

    return validationOutput
  }

  //Initializations
  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)

  // Front end error list
  errorList: any = [];

  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.getCurrentComponentName()}></${this.getCurrentComponentName()}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.getCurrentComponentName()} (componentOutput)='doSomethingOnDataReceived()'></${this.getCurrentComponentName()}>`, consoleStyle)
      console.groupEnd();
    }
    if (this._inputDataForEdit != null) this.initializeClientSearchForm(this._inputDataForEdit)
    this.subscribeToParentEvent()
  }



  /**
   * Form Trasactions
   */

  FormFieldNameMap = {
    eventType: "Event Type",
    eventDate: "Event Date",
    retypeEventDate: "Retype Event Date",
    eventTime: "Event Time",
    retypeEventTime: "Retype Time",
    causeOfDeath: "Cause of Death",
    intimationDt: "Intimation Date",
    receivedDt: "Received Date",
  }

  initializeClientSearchForm(data?) {
    let payload = data || {}
    this.claimsBasicDetailsForm = this.fb.group({
      eventType: this.validationUtilService.setValidationsForFormControl('eventType', this.CLAIMSBASICDETAILSFORMNAME, payload['eventType']),
      eventDate: this.validationUtilService.setValidationsForFormControl('eventDate', this.CLAIMSBASICDETAILSFORMNAME, this.commonUtilty.serverDOtoUIDODate(payload['eventDate'])),
      retypeEventDate: this.validationUtilService.setValidationsForFormControl('retypeEventDate', this.CLAIMSBASICDETAILSFORMNAME, this.commonUtilty.serverDOtoUIDODate(payload['eventDate'])),
      eventTime: this.validationUtilService.setValidationsForFormControl('eventTime', this.CLAIMSBASICDETAILSFORMNAME, this.commonUtilty.serverDOtoUIDOsetTime(payload['eventTime'])),
      retypeEventTime: this.validationUtilService.setValidationsForFormControl('retypeEventTime', this.CLAIMSBASICDETAILSFORMNAME, this.commonUtilty.serverDOtoUIDOsetTime(payload['eventTime'])),
      causeOfDeath: this.validationUtilService.setValidationsForFormControl('causeOfDeath', this.CLAIMSBASICDETAILSFORMNAME, payload['causeOfDeath']),
      intimationDt: this.validationUtilService.setValidationsForFormControl('intimationDt', this.CLAIMSBASICDETAILSFORMNAME, this.commonUtilty.serverDOtoUIDODate(payload['intimationDt'])),
      receivedDt: this.validationUtilService.setValidationsForFormControl('receivedDt', this.CLAIMSBASICDETAILSFORMNAME, this.commonUtilty.serverDOtoUIDODate(payload['receivedDt'])),
    });
  }

  isRequired(fieldName, formName?) {
    let nameOfForm = null
    if (formName) {
      nameOfForm = formName
    }
    else {
      nameOfForm = this.CLAIMSBASICDETAILSFORMNAME
    }
    let returnObj = this.validationUtilService.isRequired(fieldName, nameOfForm)
    return returnObj
  }

  isdateValid: any = true;
  onChange(event, type) {
    let dateCheckOutput = null

    // eventDate.isSame( moment(retypeEventDate));

    if (type == "EVENT") {
      var eventDate = moment(event, "DD-MM-YYYY");
      var retypeEventDate = moment(this.claimsBasicDetailsForm.get('retypeEventDate').value, "DD-MM-YYYY");

      this.showOutside = false;
      this.d1Visible = false;
      if (retypeEventDate == null || eventDate == null)
        dateCheckOutput = false;

      if (eventDate.format('DD-MM-YYYY') == retypeEventDate.format('DD-MM-YYYY'))
        dateCheckOutput = true;
      else
        dateCheckOutput = false;

    } else {

      this.d2Visible = false;
      var retypeEventDate = moment(event, "DD-MM-YYYY");
      var eventDate = moment(this.claimsBasicDetailsForm.get('eventDate').value, "DD-MM-YYYY");


      if (retypeEventDate == null || eventDate == null)
        dateCheckOutput = false;

      if (eventDate.format('DD-MM-YYYY') == retypeEventDate.format('DD-MM-YYYY'))
        dateCheckOutput = true;
      else
        dateCheckOutput = false;
    }

    this.isdateValid = dateCheckOutput
  }


  outisideClick(event) {
    if (this.showOutside == true)
      this.d1Visible = true;
    else
      this.d1Visible = false;
    this.showOutside = false;
  }

  t1Visible: boolean = false;
  t2Visible: boolean = false;
  timeCheck: any = true
  onTimeChange(event, type) {

    let timeCheckOutput = null
    if (type == "EVENT") {

      //this.t1Visible=false;
      var retypeTime = moment(this.claimsBasicDetailsForm.get('retypeEventTime').value, "HH:mm");
      var eventTime = moment(event, "HH:mm");

      if (retypeTime == null || eventTime == null)
        timeCheckOutput = false;

      if ((eventTime.format('HH:mm') == retypeTime.format('HH:mm')))
        timeCheckOutput = true;
      else
        timeCheckOutput = false;
    } else {

      var eventTime = moment(this.claimsBasicDetailsForm.get('eventTime').value, "HH:mm");
      var retypeTime = moment(event, "HH:mm");

      if (eventTime == null || retypeTime == null)
        timeCheckOutput = false;

      if ((eventTime.format('HH:mm') == retypeTime.format('HH:mm'))) {
        timeCheckOutput = true;
        this.t2Visible = false;
      }
      else
        timeCheckOutput = false;
    }
    this.timeCheck = timeCheckOutput;
  }

  // o.controls.eventTime == null || o.controls.retypeEventTime == null)

  public checkInvalidAndEmptyFields(Form: FormGroup, componentName) {
    let invalidFields = [];
    if (!Form.valid) {
      for (const i in Form.controls) {

        let controlName = this.commonUtilty.getControlName(Form.controls[i])
        let validationErrorList = this.validationUtilService.getUIErrorList(this.claimsBasicDetailsForm.get(controlName), this.CLAIMSBASICDETAILSFORMNAME)
        if (Form.controls[i].status === 'INVALID') {
          validationErrorList.forEach(validationError => {
            let errorDO = new ErrorDO();
            errorDO.errorMsg = validationError.errorMessage;
            errorDO.validationLevel = validationError.validationLevel
            errorDO.fieldName = controlName;
            errorDO.fieldNameDescription = this.FormFieldNameMap[controlName]
            errorDO.componentName = componentName;
            invalidFields.push(errorDO)
          })
        }
      }
    }
    return invalidFields;
  }

  // Date mask DJ's code

  d1Visible: boolean = false;
  d2Visible: boolean = false;
  showOutside: boolean = false;
  showDate(dt: string) {
    if ('d1' == dt) {
      this.showOutside = true;
      this.d1Visible = true;
    }
    else this.d2Visible = true;
  }

  hideDate(dt, val) {
    console.log("Open/Close Date", val)
    if ('d1' == dt) {
      this.showOutside = val;
      this.d1Visible = val;
    }
    else this.d2Visible = val;
  }


  showTime(tm: string) {
    if ('t1' == tm) this.t1Visible = true;
    else this.t2Visible = true;
  }

}
